module.exports = __webpack_public_path__ + "static/media/mayalogo.e5dbd7e7.png";